import classNames from 'classnames'

import { EntityProfileHeaderInfoItemText } from '../../../../Entity'

import { getUserProfileHeaderInfoItemActionsProps } from './useUserProfileHeaderInfoItemsProps.utils'

import * as styles from './useUserProfileHeaderInfoItemsProps.module.css'

export function useUserProfileHeaderInfoItemsProps({
  actionQaNames,
  handlers,
  items,
  loadingItemsLength,
  maxItemsInRow,
}) {
  function handleRenderItem({ canEdit, name, ...itemProps }) {
    return (
      <EntityProfileHeaderInfoItemText
        {...itemProps}
        actions={canEdit ? undefined : null}
        canEdit={canEdit}
        className={styles.infoItem}
        contentWrapperClassName={classNames(styles.contentWrapper, {
          [styles.editableContentWrapper]: canEdit,
        })}
        itemActionsProps={getUserProfileHeaderInfoItemActionsProps({
          actionQaNames,
          name,
        })}
      />
    )
  }

  return {
    infoItemsProps: {
      handlers,
      items,
      loadingItemsLength,
      maxItemsInRow,
      renderItem: handleRenderItem,
    },
  }
}
